<template>
    <div class="app-main info-change-page">
        <el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="14" style="display:flex;line-height:40px">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
		</el-row>
        <el-row class="mg-b5">
			<el-card class="box-card">
                <!-- 顶部搜索 -->
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
											v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
											style="width: 200px" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-select size="mini" clearable v-model="quertInfo.objMap.status" style="width:100px" placeholder="选择状态">
								<!-- <el-option label="已保存" value="0"></el-option> -->
								<el-option label="待审批" value="1"></el-option>
								<el-option label="已驳回" value="3"></el-option>
								<el-option label="已通过" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch" v-hasPermi="['gys:supplierInfo:query']">查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
                <!-- 表格 -->
                <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="`calc(100vh - 180px)`">
                    <!-- <el-table-column prop="status" label="审核状态" :show-overflow-tooltip="true" width="120" :formatter="statusFormatter"> </el-table-column> -->
                     <el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button type="text" @click="showInfo(scope.row)">{{scope.row.name}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="变更状态" :show-overflow-tooltip="true">
						<template slot-scope="scope">
                            <!-- <el-option label="已保存" value="0"></el-option>
                            <el-option label="待审批" value="1"></el-option>
                            <el-option label="已驳回" value="3"></el-option>
                            <el-option label="已通过" value="2"></el-option> -->
							<!-- <el-button type="text" @click="showInfo(scope.row)" v-if="scope.row.status == 0">已保存</el-button>
							<el-button type="text" @click="showInfo(scope.row)" v-if="scope.row.status == 1">待审批</el-button>
							<el-button type="text" @click="showInfo(scope.row)" v-if="scope.row.status == 2">已驳回</el-button>
							<el-button type="text" @click="showInfo(scope.row)" v-if="scope.row.status == 3">已通过</el-button> -->
							<span v-if="scope.row.status == 0">已保存</span>
							<span v-if="scope.row.status == 1">待审批</span>
							<span v-if="scope.row.status == 2">已通过</span>
							<span v-if="scope.row.status == 3">已驳回</span>
						</template>
					</el-table-column>
					<el-table-column prop="applyCode" label="申请单号" :show-overflow-tooltip="true" > </el-table-column>
					<el-table-column prop="createTime" label="变更日期" :show-overflow-tooltip="true" >
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime?scope.row.createTime.split(' ')[0]:''}}</span>
                        </template>
                    </el-table-column>
					<el-table-column prop="createUser" label="录入人" :show-overflow-tooltip="true" > </el-table-column>
					<!-- <el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true" > </el-table-column> -->
					<el-table-column label="操作" width="120" align="left" v-if="checkRole('gys_audit')" fixed="right">
						<template slot-scope="scope">
							<!-- 0，草稿，1未审核，3驳回，2 审核通过 -->
							<el-button type="text" size="small" v-if="scope.row.status!=1" :disabled="true">审核</el-button>
							<el-link :underline="false" v-if="scope.row.status==1" class="el-link-s" :href="`/gys/showgysinfo/${scope.row.id}?hideaudit=1&changeAudit=1`" target='_blank' type="primary">审核</el-link>
							<el-button type="text" size="small" :disabled="scope.row.status==0" @click="showAuditInfo(scope.row)" >审核详情 </el-button>
						</template>
					</el-table-column>
                </el-table>
                <!-- 分页 -->
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page" :limit.sync="quertInfo.limit" :total="count"></pagination>
				</el-row>
            </el-card>
        </el-row>
    </div>
</template>
<script>
import { getSupplierApprovalRecordList } from '@/api/gysmng/index.js'
export default {
    data(){
        return {
            tableData: [],
			count: 0,
			quertInfo: {
				page: 1, //当前页码
				limit: 20, //当前每页显示的数量
				searchTime: [],
				objMap: {
					status:'',
					firstRegist:'否',
				}
			},
        }
    },
    computed:{
    },
    created() {
		this.getList();
	},
    methods:{
        onSearch(){
            this.quertInfo.page = 1;
			this.getList();
        },
        onPagination: function (val) {
			this.quertInfo.page = val.page;
			this.quertInfo.limit = val.limit;
			this.getList();
		},
        async getList() {
			let _this = this;
			const { data: res } = await getSupplierApprovalRecordList(_this.quertInfo)
			if (res.code == 0) {
				_this.tableData = res.data;
				_this.count = res.count;
			}
        },
        showInfo(row){
			this.$router.push({path: `/gys/newgysinfo/${row.id}?hideaudit=1&changeAudit=1`});
		},
		showAuditInfo(row){
			// this.$router.push({path: '/gys/showauditinfo/'+row.id});
			// window.open(`/gys/showgysinfo/${row.id}?hide=1`)
			window.open(`/gys/showauditinfo/${row.id}`)
		},
        statusFormatter(row){
            // 0，草稿，1未审核，3驳回，2 审核通过
            if(row){
                if(row.status == 2){
                    return '已通过'
                }else if(row.status == 3){
                    return '已驳回'
                }else if(row.status == 1){
                    return '待审核'
                }else{
                    return '已保存'
                }
            }else{
                return ''
            }
        },
    }
}
</script>
<style lang="scss">
    .info-change-page{

    }
	::v-deep .el-link-s{
		font-size: 12px!important;
		margin-right: 12px;
		line-height: 1!important;
		position: relative;
		top: -1px;
	}
</style>
